// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2z60Z","right":"styles_right__2yNUv"};